'use client'

export { default } from '@speedwaymotors/clutch/Layout/Next/_globalError'
